import React, {useState, useEffect} from 'react'
import {useLocation} from "react-router-dom"
import { Tabs, Tab } from 'react-bootstrap'

import AlertComp from '../../../Reusables/AlertComp/AlertComp'
import Sources from '../../Reusables/Sources/Sources'
import {useMutation} from "react-query"
import {getdmc, getExternalSources, getSourceHotels, getRoomCategories, mapHotelsToCategory, getHotelOwner, addHoOwner, getAllExternalHotels} from "../../Super/apis"
import {mainGetUsertoken} from "../../Reusables/GetUsertoken/GetUsertoken"



 
const Index = ()=> {
  return (
      <Tabs
      defaultActiveKey="create"
      id="uncontrolled-tab-example"
      className="mb-3 title_font"
    >
      <Tab eventKey="create" title="ADD HOTEL OWNER">
          <AddHotelOwner />
      </Tab>
      <Tab eventKey="external" title="MAP CATEGORY">
        <Sources />
      </Tab>
    </Tabs>
  )
}

const AddHotelOwner = ()=> {
  const location = useLocation()
    const [usertoken, setUsertoken] = useState("")
    const [user, setUser] = useState("")
    const [sourceData, setSourceData]= useState({})
    const [showAlert, setShowAlert] = useState(false);
    const [alert, setAlertType] = useState({
        type: "",
        value: "",
    });

    const getDMCs = useMutation(getdmc, {
        onError: (e)=>{
            setAlertType({ ...alert, type: "danger", value: e.message });
            setShowAlert(true)
        }, 
        onSuccess:(e)=>{
            if(e.data.response === false) {
                setAlertType({ ...alert, type: "danger", value: e.data.message })
                setShowAlert(true)
            }
        }
    })

    const getSrcHotels = useMutation(getSourceHotels, {
        onError: (e)=>{
            setAlertType({ ...alert, type: "danger", value: e.message });
            setShowAlert(true)
        }, 
        onSuccess:(e)=>{
            if(e.data.response === false) {
                setAlertType({ ...alert, type: "danger", value: e.data.message })
                setShowAlert(true)
            }
        }
    })
    const fetchRoomCategories = useMutation(getRoomCategories, {
        onError: (e)=>{
            setAlertType({ ...alert, type: "danger", value: e.message });
            setShowAlert(true)
        }
    })
    
    const fetchHotelOwner = useMutation(getHotelOwner, {
        onError: (e)=>{
            setAlertType({ ...alert, type: "danger", value: e.message });
            setShowAlert(true)
        }, 
        onSuccess:(e)=>{
            if(e.data.response === false) {
                setAlertType({ ...alert, type: "danger", value: e.data.message })
                setShowAlert(true)
            }
        }
        
    })

    console.log({fetchHotelOwner})
    const getExSources = useMutation(getExternalSources, {
        onError: (e)=>{
            setAlertType({ ...alert, type: "danger", value: e.message });
            setShowAlert(true)
        }, 
        onSuccess:(e)=>{
            if(e.data.response === false) {
                setAlertType({ ...alert, type: "danger", value: e.data.message })
                setShowAlert(true)
            }
        }
        
    })
    const addHotelOwner = useMutation(addHoOwner, {
        onError: (e)=>{
            setAlertType({ ...alert, type: "danger", value: e.message });
            setShowAlert(true)
        },
        onSuccess: (e)=>{
            setAlertType({ ...alert, type: "success", value: e.data.message });
            setShowAlert(true)
        }
    })

    useEffect(()=>{
        mainGetUsertoken(location, setUsertoken, setUser)
        getDMCs.mutate({
            apptoken:process.env.REACT_APP_APP_TOKEN,
    
        }) 
        fetchRoomCategories.mutate()
        fetchHotelOwner.mutate()
    },[])

    useEffect(() => {
      if(sourceData.token){
        getExSources.mutate({
            apptoken: process.env.REACT_APP_APP_TOKEN,
            usertoken: sourceData.token
        })
      }
    }, [sourceData.token])

    useEffect(() => {
      if(sourceData.source){
        let sourceInfo = sourceData.source.split("/")
        getSrcHotels.mutate({
            apptoken:process.env.REACT_APP_APP_TOKEN,
            usertoken:sourceData.token,
            sourceid: sourceInfo[0],
            source: sourceInfo[1]
        })
      }
    }, [sourceData.source])


    function handleAlertClose(){
        setShowAlert(false);
    };

    function handleForm(e){
        setSourceData({...sourceData, [e.target.name]:e.target.value})
    };
    
    function handleSubmit(e){
        e.preventDefault()
        addHotelOwner.mutate({
            apptoken:process.env.REACT_APP_APP_TOKEN,
            usertoken:sourceData.token,
            hoteltoken:sourceData.hotel,
            hotoken: sourceData.hotoken
        })
    };
    return (
        <div className="row">
            <form onSubmit={handleSubmit} className="form col-12 row justify-content-center">
            {showAlert === true && (
                <AlertComp
                  variant={alert.type}
                  alertText={alert.value}
                  handleAlertClose={handleAlertClose}
                />
              )}
              <div className="row">
                <div className="form-group col-md-3 p-1">
                    <label htmlFor="dmc" className="form-label">DMC</label>
                    {  getDMCs.isLoading ?  
                        <div>
                            <div className={`spinner-border text-primary d-block mx-auto` } role="status" ></div>  
                        </div> :
                        <select name="token" id="dmc" className="form-select" value={sourceData.token} onChange={handleForm}>
                            <option value="">Select DMC</option>
                                {(getDMCs.data && getDMCs.data?.data.success !== false)&& getDMCs.data.data.map(dmc=>(
                                    <option key={dmc.id} value={dmc.token}>{dmc.first_name} - {dmc.last_name}</option>
                                    ))
                                }
                        </select>
                    }
                </div>
                <div className="form-group col-md-3 p-1 ">
                    <label htmlFor="dmc" className="form-label">Sources</label>
                    {  getExSources.isLoading ? 
                        <div>
                            <div className={`spinner-border text-primary d-block mx-auto` } role="status" ></div>   
                        </div> :
                        <select name="source" id="hotel" className="form-select" value={sourceData.source} onChange={handleForm}>
                            <option value="">Select Source</option>
                                { (getExSources.data && getExSources.data.data.success !== false) && getExSources.data.data.sources.map(source=>(
                                    <option key={source.id} value={source.id + "/" + source.name}>{source.name}</option>
                                    ))
                                }
                        </select>
                    }
                </div>
                </div>
                <div className="row">

                <div className="form-group col-md-3 p-1 ">
                    <label htmlFor="dmc" className="form-label">Hotels</label>
                    {  getSrcHotels.isLoading ? 
                        <div>
                            <div className={`spinner-border text-primary d-block mx-auto` } role="status" ></div>   
                        </div> :
                        <select name="hotel" id="hotel" className="form-select" value={sourceData.hotel} onChange={handleForm}>
                            <option value="">Select Hotel</option>
                                { (getSrcHotels.data && getSrcHotels.data.data.success !== false) && getSrcHotels.data.data.Hotels.map(hotel=>(
                                    <option key={hotel.id} value={hotel.token}>{hotel.hotelname}</option>
                                    ))
                                }
                        </select>
                    }
                </div>
                <div className="form-group col-md-3 p-1 ">
                    <label htmlFor="dmc" className="form-label">Hotel Owner</label>
                    {  fetchHotelOwner.isLoading ? 
                        <div>
                            <div className={`spinner-border text-primary d-block mx-auto` } role="status" ></div>   
                        </div> :
                        <select name="hotoken" id="hotoken" className="form-select" value={sourceData.hotoken} onChange={handleForm}>
                            <option value="">Select Hotel Owner</option>
                                { (fetchHotelOwner.data && fetchHotelOwner.data.data.message !== "No results") && fetchHotelOwner.data.data.map(owner=>(
                                    <option key={owner.id} value={owner.token}>{owner.first_name} - {owner.last_name}</option>
                                    ))
                                }
                        </select>
                    }
                </div>
                </div>
                <div className="row">
                <div className="form-group col-md-3 py-4 px-2">
                    <button className="btn btn-primary">{ addHotelOwner.isLoading ? <div className={`spinner-border text-primary` } role="status" ></div> : "Add Hotel Owner"}</button>
                </div>
                </div>
            </form>
        </div>
    )
}


const AllSources = () => {
  return (
    <main className="pt-4 px-lg-4 px-3"  style={{ minHeight: "83vh" }}>
    <header className=" mb-3 d-flex justify-content-between align-items-center dashHeader">
      <h4 className="text-primary">Sources</h4>
    </header>

    <div className="content">
        <Index />
    </div>
    </main>
  )
}

export default AllSources